import Http from '@/services/http'

// 更新role
export const updateRole = (params: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/role/item/updateRoleInfo',
    params,
    method: 'post',
    returnAll: true
  })
}
// 删除role
export const deleteRole = (data: any) => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/role/item/delRoleInfoId/${data.id}`,
    method: 'DELETE',
    returnAll: true
  })
}
// 添加role
export const saveRole = (params: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/role/item/saveRoleInfo',
    params,
    method: 'post',
    returnAll: true
  })
}
// 添加资料
export const saveRoleInfoDetails = (params: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/role/item/saveRoleInfoDetails',
    params,
    method: 'post',
    returnAll: true
  })
}
// role详情
export const roleDetail = (data: any) => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/role/item/getRoleInfo/${data.id}`,
    method: 'get',
    returnAll: true
  })
}
// role列表查询
export const queryRole = (params: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/role/item/getRoleList',
    params,
    method: 'get',
    returnAll: true
  })
}

// 查询数字人接口
export const queryAvatar = (params: any) => {
  return Http.request({
    // url: '/metaman/open/avatar/get/man/infos',
    url: '/cwhCopilot/copilot/v1/role/item/getDigitalManPageList',
    params,
    method: 'get',
    returnAll: true
  })
}
// 下载接口
export const getFilePort = (params: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/role/item/downLoadStream',
    params,
    method: 'post',
    returnAll: true,
    config: {
      responseType: 'blob',
      timeout: 0
    }
  })
}

// 判断当前上传的文档融合后是否大于10MB
export const saveMacChatMessage = (params: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/role/item/saveMacChatMessage',
    params,
    method: 'post',
    returnAll: true
  })
}
// 删除资料
export const delRoleInfoDetails = (params: any) => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/role/item/delRoleInfoDetails/${params.detailsId}`,
    params,
    method: 'delete',
    returnAll: true
  })
}
